import Seo from "@/components/common/Seo";
import ContactForm from "@/components/home/ContactForm";
import GlowOrbs from "@/components/common/GlowOrbs";
import SectionHeading from "@/components/common/SectionHeading";

export default function Contact() {
  return (
    <div data-testid="page-contact">
      <Seo title="Contact Us" description="Talk to a SKVY Harmony Placement US career advisor. Free 30-min consultation and resume audit." path="/contact" />

      <section className="relative pt-16 pb-8 overflow-hidden">
        <GlowOrbs />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
          <SectionHeading
            eyebrow="Get in touch"
            title="Let's talk about your US tech career."
            sub="Whether you're on OPT, CPT, H-1B or hiring — a senior US advisor will respond within 24 business hours."
          />
        </div>
      </section>

      <ContactForm compact />
    </div>
  );
}
